import { gql } from "@apollo/client";

export const LIST_REACTION_QUESTIONS = gql`
  query ListReactionQuestions(
    $limit: Int!
    $offset: Int!
    $order_by: [posts_order_by!]
  ) {
    posts(
      where: {
        post_type: { _eq: "REACTION_QUESTION" }
        is_deleted: { _eq: false }
      }
      limit: $limit
      offset: $offset
      order_by: $order_by
    ) {
      id
      title
      published
      published_date
      created_date
      created_by
      comments_aggregate(
        where: {
          gif_url: { _is_null: false }
          is_deleted: { _eq: false }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user_id
        }
      }
      post_views_aggregate {
        aggregate {
          count
        }
      }
    }
    posts_aggregate(
      where: {
        post_type: { _eq: "REACTION_QUESTION" }
        is_deleted: { _eq: false }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_REACTION_QUESTION = gql`
  query GetReactionQuestion($id: String!) {
    posts_by_pk(id: $id) {
      id
      title
      published
      published_date
      created_date
      created_by
      comments_aggregate(
        where: {
          gif_url: { _is_null: false }
          is_deleted: { _eq: false }
        }
      ) {
        aggregate {
          count
        }
        nodes {
          user_id
        }
      }
      post_views_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const CREATE_REACTION_QUESTION = gql`
  mutation CreateReactionQuestion($title: String!, $published: Boolean!, $published_date: timestamptz) {
    insert_posts_one(
      object: {
        title: $title
        post_type: "REACTION_QUESTION"
        published: $published
        published_date: $published_date
        is_deleted: false
        ai_checked: "now()"
      }
    ) {
      id
      title
      published
      published_date
      created_date
    }
  }
`;

export const UPDATE_REACTION_QUESTION = gql`
  mutation UpdateReactionQuestion(
    $id: String!
    $set: posts_set_input!
  ) {
    update_posts_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      title
      published
      published_date
    }
  }
`;

export const SOFT_DELETE_REACTION_QUESTION = gql`
  mutation SoftDeleteReactionQuestion($id: String!) {
    update_posts_by_pk(
      pk_columns: { id: $id }
      _set: { is_deleted: true }
    ) {
      id
    }
  }
`;

export const GET_QUESTION_INTERESTS = gql`
  query GetQuestionInterests($postId: String!) {
    post2interest(
      where: {
        post_id: { _eq: $postId }
        is_deleted: { _eq: false }
      }
    ) {
      id
      interest_id
      interest {
        id
        name_en
        depth
        parent_id
        color
      }
    }
  }
`;

export const GET_INTERESTS_FOR_ASSIGNMENT = gql`
  query GetInterestsForAssignment {
    interests(
      where: { is_deleted: { _eq: false }, active: { _eq: true } }
      order_by: { name_en: asc }
    ) {
      id
      name_en
      depth
      parent_id
      color
    }
  }
`;

export const ASSIGN_INTEREST = gql`
  mutation AssignInterest($postId: String!, $interestId: String!) {
    insert_post2interest_one(
      object: { post_id: $postId, interest_id: $interestId, is_deleted: false }
    ) {
      id
    }
  }
`;

export const REMOVE_INTEREST = gql`
  mutation RemoveInterest($id: String!) {
    update_post2interest_by_pk(
      pk_columns: { id: $id }
      _set: { is_deleted: true }
    ) {
      id
    }
  }
`;
